import { render, staticRenderFns } from "./view-program.vue?vue&type=template&id=d817571a&"
import script from "./view-program.vue?vue&type=script&lang=js&"
export * from "./view-program.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports